import CREApi from './_creApi';
import httpClient from '@/apis/base/httpclient';
class CRERepExportListAPI extends CREApi {
  constructor() {
    super();
  }
  controllerName = 'CRERepExportTaxLists';

  /**
   * Dữ liệu xuất khẩu báo cáo
   */
  getDataExportReport(param) {
    let request = {
      url: this.getAPIUrl() + '/ExportFinancialReport',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Dữ liệu xuất khẩu báo cáo
   */
  export(param) {
    let request = {
      url: this.getAPIUrl() + '/Export',
      data: param,
    };

    return httpClient.postAsync(request);
  }
}

export default new CRERepExportListAPI();
